import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Avatar, Box, Typography, ButtonBase, useMediaQuery } from '@mui/material';

// project imports
import ProfileSection from './ProfileSection';
import { useSelector } from 'react-redux';
// assets
import { IconMenu2 } from '@tabler/icons-react';

import logo from 'assets/images/auth/logo.svg';
import question from 'assets/images/auth/question.svg';
import Ordinary from 'assets/images/rights/ordinary.png';
import Senior from 'assets/images/rights/senior.png';
import Major from 'assets/images/rights/major.png';
import Private from 'assets/images/rights/private.png';
import { useNavigate } from 'react-router';
import { API } from 'utils/api';
import { getUserInfo, showError } from 'utils/common';
import LogoSection from '../LogoSection';

const Header = ({ handleLeftDrawerToggle, rightsCenterRef, docCenterRef, personalCenterRef, logoToHomeRef }) => {
  const theme = useTheme();
  const siteInfo = useSelector((state) => state.siteInfo);
  const userinfo = getUserInfo();
  const navigate = useNavigate();
  const [rightsLevel, setRightsLevel] = useState(0);
  const matchDownMd = useMediaQuery(theme.breakpoints.down('md'));
  const getUserRight = async () => {
    const res = await API.get('/api/user/rights');
    const { success, message, data } = res.data;
    if (success) {
      setRightsLevel(data);
    } else {
      showError(message);
    }
  };

  const handleRightsIcon = () => {
    switch (rightsLevel) {
      case 1:
        return Senior;
      case 2:
        return Major;
      case 3:
        return Private;
      default:
        return Ordinary;
    }
  };

  const shipRights = () => {
    navigate('/profile/rights');
  };
  const onDoc = () => {
    navigate('/panel/text-doc');
  };

  useEffect(() => {
    getUserRight().then();
  }, []);

  return (
    <>
      <Box
        sx={{
          width: 228,
          display: 'flex',
          [theme.breakpoints.down('md')]: {
            width: 'auto'
          }
        }}
      >
        <Box component="span" sx={{ display: { xs: 'none', md: 'block' }, flexGrow: 1, minWidth: '200px' }} ref={logoToHomeRef}>
          <LogoSection />
        </Box>
        {userinfo?.role == 1000 && <div style={{ display: 'flex', whiteSpace: 'nowrap', fontWeight: '600', fontSize: '18px', margin: 'auto 0px' }}>企业管理后台</div>}
      </Box>
      <Box sx={{ flexGrow: 1 }} />
      <Box sx={{ flexGrow: 1 }} />

      <div style={{ display: 'flex', alignItems: 'center' }}>
        <a target="_blank" style={{ textDecoration: 'none' }} ref={docCenterRef}>
          <Typography onClick={() => onDoc()} variant="subtitle2" color="#000022D9" sx={{ textDecoration: 'none', cursor: 'pointer' }}>
            <img src={question} alt="question" style={{ verticalAlign: 'top', width: '18px', height: '20px', marginRight: '5px' }} />
            帮助中心
          </Typography>
        </a>

        {!userinfo?.enterprise_auth_status &&userinfo?.role !== 1000 && (
          <img
            ref={rightsCenterRef}
            width={25}
            height={25}
            style={{ marginLeft: '10px', objectFit: 'contain', cursor: 'pointer' }}
            src={handleRightsIcon()}
            onClick={() => shipRights()}
          />
        )}
        <div ref={personalCenterRef}>
          <ProfileSection />
        </div>
      </div>
    </>
  );
};

Header.propTypes = {
  handleLeftDrawerToggle: PropTypes.func
};

export default Header;
